import React from 'react'

interface HamburgerMenuProps {
  isOpen: boolean
  onClick: () => void
  lineColor: string
  className?: string
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  isOpen,
  onClick,
  lineColor,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-8 h-5 flex flex-col justify-center items-end gap-[7px] ${className}`}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
    >
      <span
        className={`block h-0.5 ${lineColor} transition-all duration-300 ease-in-out ${
          isOpen ? 'w-0 opacity-0 translate-y-[9px]' : 'w-[26px] opacity-100 translate-y-0'
        }`}
      ></span>
      <span className={`block h-0.5 w-8 ${lineColor} transition-all duration-300`}></span>
      <span
        className={`block h-0.5 ${lineColor} transition-all duration-300 ease-in-out ${
          isOpen ? 'w-0 opacity-0 -translate-y-[9px]' : 'w-[22px] opacity-100 translate-y-0'
        }`}
      ></span>
    </button>
  )
}